/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as actionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';

export const dispatchDrugList = (data) => ({
  type: actionTypes.GET_ALL_DRUG_LIST,
  payload: data,
});

export const dispatchDrugFamily = (data) => ({
  type: actionTypes.GET_DRUG_FAMILY,
  payload: data,
});

export const dispatchremoveDrug = (data) => ({
  type: actionTypes.REMOVE_DRUG_FROM_LIST,
  payload: data,
});

export const dispatchNdcDetails = (data) => ({
  type: actionTypes.GET_NDC_DETAILS,
  payload: data,
});

export const dispatchDrugSection = (data) => ({
  type: actionTypes.VIEW_DRUG_SECTION,
  payload: data,
});

export const dispatchRowHighlight = (data) => ({
  type: actionTypes.ROW_HIGH_LIGHT,
  payload: data,
});

export const dispatchDrugFamilyDetails = (data) => ({
  type: actionTypes.DRUG_FAMILY_DETAILS,
  payload: data,
});

export const dispatchSaveDrugFamily = (data) => ({
  type: actionTypes.SAVE_DRUG_FAMILY,
  payload: data,
});

export const saveDrugSeq = (data) => ({
  type: actionTypes.SAVE_DRUG_SEQ,
  payload: data,
});

export const LinkDrugFields = (data) => ({
  type: actionTypes.LINK_DRUG_FIELDS,
  payload: data,
});

export const buttonEnable = (data) => ({
  type: actionTypes.BUTTON_ENABLE,
  payload: data,
});

export const saveDrugFamilyVO = (data) => ({
  type: actionTypes.SAVE_DRUGFAMILY_VO,
  payload: data,
});

export const selectNdcParam = (data) => ({
  type: actionTypes.SELECT_NDC_PARAM,
  payload: data,
});

export const viewDrugDetailModal = (data) => ({
  type: actionTypes.VIEW_DRUG_DETAIL_MODAL,
  payload: data,
});

export const getDrugList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRUG_LIST, values)
    .then((response) => {
      dispatch(dispatchDrugList(response.data && response.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchDrugList({ error: 'API failed' }));
    });
};

export const getDrugFamily = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DRUG_FAMILY, values)
    .then((response) => {
      dispatch(dispatchDrugFamily(response.data && response.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchDrugFamily({ error: 'API failed' }));
    });
};

export const removeDrugFromList = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.REMOVE_DRUG_FROM_LIST,
      values
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const getNDCDetails = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.NDC_DETAILS, values);
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const viewDrugSection = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.VIEW_DRUG_SECTION, values)
    .then((response) => {
      dispatch(dispatchDrugSection(response.data));
    })
    .catch((error) => {
      dispatch(dispatchDrugSection({ error: 'API failed' }));
    });
};

export const getDrugFamilyDetail = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.GET_ALL_DRUG_FAMILIES_BY_SEQUNUM,
      values
    );
    if (response.data.message === 'SUCESS') {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const saveDrugFamily = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.SAVE_DRUG_FAMILIES,
      values
    );
    if (response.data.message === 'SUCESS') {
      return response.data;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};

export const clearReduxforLinkNewDrugsToDrugFamily = () => (dispatch) => {
  dispatch(LinkDrugFields({}));
  dispatch(buttonEnable({}));
  dispatch(dispatchDrugList([]));
  dispatch(saveDrugFamilyVO({}));
  dispatch(viewDrugDetailModal({}));
  dispatch(dispatchRowHighlight({}));
  dispatch(dispatchDrugSection({}));
  dispatch(dispatchDrugList([]));
  dispatch(dispatchDrugFamily([]));
  dispatch(getDrugList({}));
};
